// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1FhBU","fileBtn":"File_fileBtn__2cLfq","closeBtn":"File_closeBtn__73mRU","fileSelected":"File_fileSelected__3t76Q","disabled":"File_disabled__9RRfO"};